/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './unlock_notification';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "NotificationService": {
                    "methods": {
                      "UnlockNotification": {
                        "requestType": ".squareup.sfs.external.service.UnlockNotificationRequest",
                        "responseType": ".squareup.sfs.external.service.UnlockNotificationResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.NotificationService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPCs for creating Notifications.
 * --
 *
 * SOURCE NotificationService @ squareup/sfs/external/services/notification/notification_service.proto at 11:1
 */
export const NotificationService = $root.lookupService('squareup.sfs.external.service.NotificationService');